import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, ButtonModel } from '@notino/react-styleguide';
import { AvailabilityState } from '@notino/shared/definitions/types';

import { useFetchProductAlternatives } from '@containers/ProductDetailContainer/hooks/useFetchProductAlternatives';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useTrackingContext } from '@context/tracking/TrackingContext';
import { dispatchTrackingEvent } from '@context/tracking/utils';
import { PRODUCT_ALTERNATIVES_ELEMENT_ID } from '@lib/constants';

import { ShowOnDesktop } from '../../styled';
import { productBaseInfoMessages } from '../messages';

export const SimilarProductsButton = () => {
  const { data } = useFetchProductAlternatives();
  const { product } = useProductDetailContext();
  const { getTimeFromInit } = useTrackingContext();

  const alreadyFetchedButNoProducts =
    data &&
    Boolean(data.getOutOfStockAlternatives?.recommendedProducts?.length) ===
      false;

  const everyProductUnavailable = product.variants.every(
    (v) => v.availability.state !== AvailabilityState.CanBeBought
  );

  if (alreadyFetchedButNoProducts || !everyProductUnavailable) {
    return null;
  }

  return (
    <ShowOnDesktop>
      <Button
        href={`#${PRODUCT_ALTERNATIVES_ELEMENT_ID}`}
        onClick={() =>
          dispatchTrackingEvent({
            event: 'element_click',
            _clear: true,
            element: {
              timing: getTimeFromInit(),
              name: 'product_alternatives',
              type: 'product_detail',
              interaction: 'button',
            },
          })
        }
        buttonStyle={ButtonModel.Styles.secondary}
      >
        <FormattedMessage {...productBaseInfoMessages.similarProductsButton} />
      </Button>
    </ShowOnDesktop>
  );
};
